import { render, staticRenderFns } from "./importNoticeCommonNew.vue?vue&type=template&id=523240e7&scoped=true"
import script from "./importNoticeCommonNew.vue?vue&type=script&lang=js"
export * from "./importNoticeCommonNew.vue?vue&type=script&lang=js"
import style0 from "./importNoticeCommonNew.vue?vue&type=style&index=0&id=523240e7&prod&lang=less&scoped=true"
import style1 from "./importNoticeCommonNew.vue?vue&type=style&index=1&id=523240e7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523240e7",
  null
  
)

export default component.exports